<h1 class="text-3xl font-medium text-neutral-800">
  <ng-content></ng-content>
</h1>
